import {Base} from "@/api/Base"

export class SubjectDelete extends Base {
    path = "subject/delete"
}